import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNativePlatform } from "@/hooks/useNativePlatform";

/**
 * Android/iOS hardware back: go back in app history when possible.
 * On the root screen (no history), do nothing — never exit the app from back.
 */
export function useNativeBackButton() {
  const navigate = useNavigate();
  const { isNative } = useNativePlatform();

  useEffect(() => {
    if (!isNative) return;

    let active = true;
    let removeListener: (() => void) | undefined;

    void import("@capacitor/app").then(({ App }) => {
      if (!active) return;

      void App.addListener("backButton", () => {
        if (window.history.length > 1) {
          navigate(-1);
        }
      }).then((handle) => {
        if (!active) {
          void handle.remove();
          return;
        }
        removeListener = () => {
          void handle.remove();
        };
      });
    });

    return () => {
      active = false;
      removeListener?.();
    };
  }, [navigate, isNative]);
}
